import PropTypes from "prop-types";
import { Button } from "shards-react";

import {
    Container,
    Information,
    PageContent,
    Icon,
    InformationContainer
} from "./GenerateCredentialsComponentStyles";
import Shards from "../../components/Shards";

const GenerateCredentialsComponent = ({
    isFetchingKey,
    name = "",
    navigateToSelectOrganization,
    title = "Geração de credenciais do Eitri",
    hasError = false
}) => {
    const showMessageDetails = () => {
        const messages = {
            success: {
                subTitle: name
                    ? `${name}, credenciais geradas.`
                    : "Credenciais geradas.",
                description:
                    "Você pode fechar está janela e continuar usando a CLI ou navegar pelo Console."
            },
            error: {
                subTitle: name
                    ? `${name}, não foi possível gerar as credenciais.`
                    : "Não foi possível gerar as credenciais",
                description:
                    "Você pode explorar o Console ou tentar novamente em alguns minutos."
            },
            loading: {
                subTitle: name
                    ? `${name}, gerando suas credenciais...`
                    : "gerando suas credenciais...",
                description: "..."
            }
        };

        if (isFetchingKey) {
            return {
                ...messages.loading
            };
        }

        return {
            ...(hasError ? messages.error : messages.success)
        };
    };

    const iconConfig = () => {
        const defaultFontSize = 48;

        const icons = {
            loading: {
                name: "rotate_right",
                style: {
                    color: "#000000",
                    fontSize: defaultFontSize
                }
            },
            success: {
                name: "verified_user",
                style: {
                    color: "#52816D",
                    fontSize: defaultFontSize
                }
            },
            error: {
                name: "no_encryption_gmailerrorred",
                style: {
                    color: "#FF0000",
                    fontSize: defaultFontSize
                }
            }
        };

        if (isFetchingKey) {
            return {
                ...icons.loading
            };
        }

        return {
            ...(hasError ? icons.error : icons.success)
        };
    };

    const buttonConfig = () => {
        const config = {
            success: {
                outline: false,
                theme: "primary"
            },
            error: {
                outline: true,
                theme: "secondary"
            }
        };

        return {
            ...(hasError ? config.error : config.success)
        };
    };

    return (
        <Container>
            <PageContent>
                <Shards.Card
                    style={{
                        borderColor: hasError ? "red" : "transparent",
                        borderWidth: 1,
                        borderStyle: "solid"
                    }}
                >
                    <Shards.CardHeader>{title}</Shards.CardHeader>
                    <Shards.CardBody>
                        <Icon
                            style={iconConfig().style}
                            className="material-icons"
                        >
                            {iconConfig().name}
                        </Icon>
                        <InformationContainer>
                            <h4
                                style={{
                                    fontWeight: hasError ? "bold" : "normal"
                                }}
                            >
                                {showMessageDetails().subTitle}
                            </h4>
                            <Information>
                                {showMessageDetails().description}
                            </Information>
                            {!isFetchingKey && (
                                <Button
                                    size={"lg"}
                                    outline={buttonConfig().outline}
                                    theme={buttonConfig().theme}
                                    pill
                                    style={{ margin: 10, marginTop: 50 }}
                                    className={"cypress--confirm-button"}
                                    onClick={() =>
                                        navigateToSelectOrganization()
                                    }
                                >
                                    Navegar no console
                                </Button>
                            )}
                        </InformationContainer>
                    </Shards.CardBody>
                </Shards.Card>
            </PageContent>
        </Container>
    );
};

GenerateCredentialsComponent.propTypes = {
    isFetchingKey: PropTypes.bool,
    name: PropTypes.string,
    navigateToSelectOrganization: PropTypes.func,
    title: PropTypes.string,
    hasError: PropTypes.bool
};
export default GenerateCredentialsComponent;
